<div class="table-responsive" style="width: 460">
  <table suiteRfbTable>
    <caption>Receitas</caption>
    <thead>
      <tr>
        @if (this.exibirLabels) {
        <th class="text-center min-width"></th>
        }
        <th class="text-center min-width">Receita</th>
        <th class="text-center min-width">Valor</th>
        @if (this.exibirSaldos) {
        <th class="text-center min-width">Saldo</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (valorDocumento of this.valoresDocumento; track valorDocumento.tipo) {
      @if (valorDocumento.valor != null) {
      <tr class="vertical-align-middle" [class.fw-bold]="valorDocumento.tipo === TipoValorEnum.TOTAL">
        @if (this.exibirLabels) {
        <td class="text-center">
          {{ valorDocumento.tipo | tipoValorDocumentoPipe }}
        </td>
        }

        <td class="text-center">
          @if (valorDocumento.tipo !== TipoValorEnum.TOTAL) {
          <via-codigo-receita [codigo]="valorDocumento.receita?.codigo"></via-codigo-receita>
          }
          @else if (!this.exibirLabels) {
          {{ valorDocumento.tipo | tipoValorDocumentoPipe }}
          }
        </td>

        <td class="text-right">
          {{ valorDocumento.valor != null ? (valorDocumento.valor | formatCurrency) : "-"}}
        </td>

        @if (this.exibirSaldos) {
        <td class="text-center min-width text-nowrap">
          @if (valorDocumento.mensagem != null && valorDocumento.mensagem != "") {
          {{ valorDocumento.mensagem }}
          }
          @else {
          {{ valorDocumento.saldo != null ? (valorDocumento.saldo | formatCurrency) : "-" }}
          }
        </td>
        }
      </tr>
      }
      }
    </tbody>
  </table>
</div>